<template>
  <div>
    <div class="uk-grid uk-flex-middle uk-margin-top">
      <div class="uk-width-1-1 uk-margin-bottom">
        <hr/>
      </div>

      <div class="uk-width-auto">
        <h3 class="mp-color-console">Response</h3>
      </div>

      <!-- Request info toggle -->
      <div class="uk-width-expand uk-text-right">
        <button class="uk-button uk-button-link mp-text-decoration-none" @click="showRequest = !showRequest">{{ `${showRequest ? 'Hide' : 'Show'}` }} Request</button>
      </div>

      <!-- View togglers -->
      <div class="uk-width-auto" v-if="response.code === 200">
        <span :class="[selectedView === 'tree' ? 'mp-response-format-selected' : '', 'mp-response-format']"><button class="uk-button uk-button-link uk-margin-right mp-text-decoration-none" @click="selectedView = 'tree'">View Tree <i class="far fa-code-merge" /></button></span>
        <span :class="[selectedView !== 'tree' ? 'mp-response-format-selected' : '', 'mp-response-format']"><button class="uk-button uk-button-link mp-text-decoration-none" @click="selectedView = 'raw'">View Raw <i class="fas fa-brackets-curly"/></button></span>
      </div>

      <!-- Status code -->
      <div class="uk-width-auto" v-if="response.code">
        <p class="uk-text-bold" :class="response.code === 200 ? 'uk-text-success' : 'uk-text-danger'">
          <i class='far fa-check' v-if="response.code === 200" />
          <i class="far fa-exclamation-triangle" v-else />
          {{ response.code }}
        </p>
      </div>

      <!-- Status message bar -->
      <div class="uk-width-1-1 uk-margin-top">
        <p :class="[response.code === 200 ? 'uk-alert-success' : 'uk-alert-danger', 'uk-alert']">{{ response.message === undefined ? `HTTP ${response.code} Error` : response.message }}</p>
      </div>

        <!-- Request info -->
      <div v-if="showRequest" class="uk-width-1-1 uk-margin-top">
        <h4 class="mp-color-console">Request Detail</h4>
        
        <!-- Basic request info -->
        <table class="uk-table uk-table-striped">
          <tr>
            <td class="uk-text-bold">URL</td>
            <td>{{ requestInfo.url }}</td>
          </tr>
          <tr>
            <td class="uk-text-bold">Method</td>
            <td>{{ requestInfo.method }}</td>
          </tr>
          <tr v-if="requestInfo.contentType">
            <td class="uk-text-bold">Content-Type</td>
            <td>{{ requestInfo.contentType }}</td>
          </tr>
        </table>
        
        <!-- Request Body for POST requests with special format -->
        <div v-if="requestInfo.requestBody" class="uk-margin-top">
          <h5 class="mp-color-console">Request Body</h5>
          <div class="uk-alert uk-alert-primary">
            <pre>{{ requestInfo.requestBody }}</pre>
          </div>
        </div>
        
        <!-- Regular params display -->
        <div v-else-if="requestInfo.params && Object.keys(requestInfo.params).length > 0" class="uk-margin-top">
          <h5 class="mp-color-console">Parameters</h5>
          <table class="uk-table uk-table-striped uk-table-small">
            <tr v-for="(value, key, index) in requestInfo.params" :key="index">
              <td class="uk-text-bold" style="text-transform:capitalize;">{{ key }}</td>
              <td>{{ typeof value === 'object' ? JSON.stringify(value) : value }}</td>
            </tr>
          </table>
        </div>
        
        <!-- Additional request details for debugging errors -->
        <div v-if="response.requestDetails" class="uk-margin-top">
          <h5 class="mp-color-console">Request Debugging Information</h5>
          <div class="uk-alert uk-alert-primary">
            <p><strong>URL:</strong> {{ response.requestDetails.url }}</p>
            <p><strong>Method:</strong> {{ response.requestDetails.method }}</p>
            <p v-if="response.requestDetails.headers"><strong>Headers:</strong> {{ JSON.stringify(response.requestDetails.headers, null, 2) }}</p>
            <div v-if="response.requestDetails.body">
              <p><strong>Request Body:</strong></p>
              <pre>{{ response.requestDetails.body }}</pre>
            </div>
          </div>
        </div>
      </div>

      <!-- Formatted response (show for tree to keep in memory as gen is expensive. If for highlightjs as it breaks) -->
      <div class="uk-width-1-1 uk-margin-top" v-if="response.code === 200">
        <h4 class="mp-color-console"><span style="text-transform:capitalize;">{{ selectedView }}</span> View</h4>
        <json-view v-show="selectedView === 'tree'" :data="response.data" :maxDepth="3" class="mp-json-view" :colorScheme="'dark'"></json-view>
        <highlight-code lang="javascript" v-if="selectedView !== 'tree'">{{ response.data }}</highlight-code>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "EndpointResponse",
    props: ["response", "requestInfo"],
    data: function () {
      return {
        selectedView: "tree",
        showRequest: true
      }
    }
  }
</script>

<style lang="scss">
  .mp-response-format {
    opacity: 0.5;
    &.mp-response-format-selected {
      font-weight: bold;
      opacity: 1;
    }
  }
  .json-view-item.mp-json-view.root-item.dark {
    background: #2b2b2b;
    color: #f8f8f2;
    font-family: Consolas, monaco, monospace;
    font-size: 0.875rem;
    padding: 5px;
    box-sizing: border-box;
    overflow-x: auto;

    --vjc-key-color: #abe338;
    --vjc-valueKey-color: #abe338;
    --vjc-string-color: #abe338;
    --vjc-number-color: #f5ab35;
    --vjc-boolean-color: #f5ab35;
    --vjc-null-color: #f5ab35;
    --vjc-arrow-size: 4px;
    --vjc-arrow-color: white;
    --vjc-hover-color: rgba(0, 0, 0, 0.15);

    .value-key, .data-key {
      font-weight: normal;
      padding: 3px 0;
    }

    .chevron-arrow {
      border-right-width: 2px;
      border-bottom-width: 2px;
    }
  }
</style>
